














import { Component, Vue } from 'vue-property-decorator';

import { Order } from '@/models/Order';
import { OrderType } from '@/constants/OrderType';
import { ContractService } from '@/services/ContractService';
import { StateManager } from '@/services/StateManager';
import { utils } from 'ethers';
import { BigNumber } from 'ethers/utils';
import * as Helper from '@/helpers/Utils';

export default class MyOrders extends Vue {
  private state = StateManager.GetInstance().GetState();

  get myorders(): Order[] {
    return this.state.ownOrders;
  }

  public rateUnit(rate: BigNumber) {
    const rateForDisplay = Helper.Utils.PriceIncludingDecimals(rate);
    return Helper.Utils.ComputeOptimalPriceUnit(rateForDisplay);
  }

  public displayQuantity(quantity: BigNumber) {
    return Helper.Utils.FormatFCCountForDisplay(quantity);
  }

  public displayRate(rate: BigNumber) {
    const rateForDisplay = Helper.Utils.PriceIncludingDecimals(rate);
    return utils.formatUnits(rateForDisplay, this.rateUnit(rate));
  }

  public actionClicked(order: Order) {
    ContractService.RetractOrder(order);
  }

  public showInConsole(prefix: string, object: any) {
    Helper.Utils.LogText('Info: ' + prefix + object.toString());
  }
}
